<div class="modal-header">
  <h4 class="modal-title">
    {{ 'Doc::CustomerProject:Tracking' | abpLocalization }}
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
</div>
<div class="modal-body pt-3">
  <div class="container">
    @for (hierarchy of hierarchies.slice().reverse(); let i = $index; track hierarchy) {
      <div class="row-item">
        <div>{{ hierarchy.documentDate }}</div>
        <div>
          @if (hierarchy.isClosedGlobal) {
            {{ 'Doc::CustomerProject:Closed' | abpLocalization }}
          } @else if (hierarchy.statusGlobalId != null) {
            {{ hierarchyStatus.getStatusLabel(hierarchy) }}
          } @else {
            {{ 'Doc::CustomerProject:InProgress' | abpLocalization }}
          }
        </div>
        <div>
          <document-customer-project-hierarchy [hierarchyInput]="hierarchy">
          </document-customer-project-hierarchy>
        </div>
      </div>
    }
  </div>
</div>
